export class AnimationStyles {
  constructor(public styles: {[key: string]: string | number}[]) {}
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
